import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const LEVEL_TONE = {
  beginner: 'beg',
  intermediate: 'int',
  moderate: 'int',
  advanced: 'adv',
  expert: 'pro',
  professional: 'pro',
};

export default function SeekingMemberChip({ instrument, level, className = '' }) {
  const tone = LEVEL_TONE[String(level || '').toLowerCase()] || 'beg';
  const classes = ['seeking-member-chip', `seeking-member-chip--${tone}`, className].filter(Boolean).join(' ');
  return (
    <div className={classes}>
      <span className="seeking-member-chip__instrument">{instrument}</span>
      {level ? <span className="seeking-member-chip__level">{level}</span> : null}
    </div>
  );
}

SeekingMemberChip.propTypes = {
  instrument: PropTypes.node.isRequired,
  level: PropTypes.string,
  className: PropTypes.string,
};
